import React from 'react';
import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import './RealEstateErp.css'; 

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const letterVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 50,
    },
  },
};

const RealEstateErp = () => {
  return (
    <div className="container text-center d-flex flex-column justify-content-center align-items-center comingSooncontainer">
      <h1 className='erp-heading'>Real Estate ERP</h1>
      


      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
        className="mb-10"
      >
        {/* {'Coming Soon'.split('').map((letter, index) => (
          <motion.span key={index} variants={letterVariants} className="display-1">
            {letter}
          </motion.span>
        ))} */}
        <iframe src="https://lottie.host/embed/b46d86b1-7742-403e-a0cf-a7de01aaecf1/GBLeYf49xf.json" className='comingSoonIframe'></iframe>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, type: 'spring', stiffness: 50 }}
        className="lead"
      >
        Stay tuned, we appreciate your patience.
      </motion.div>
    </div>
  );
};

export default RealEstateErp;
